import {emptyCareersMessage, filterCareers} from './careersList.util.js';

const {KitModule, registerModule} = window;

class CareersList extends KitModule {
    constructor($element) {
        super($element);
        this.department = 'None';
        this.jobs = (this.$jobs || []).map((element) => ({
            element, department: element.dataset.department, location: element.dataset.location,
        }));
        this.$filters?.addEventListener('click', this);
        this.$filters?.addEventListener('change', this);
        this.$noResultsMessage.addEventListener('click', this);
        if (this.$filters) this.$filters.hidden = false;
        this.updateResults();
    }

    onInitialize() {
        this.onViewportResize();
    }

    onViewportResize() {
        this.$results.tabIndex = this.isDesktop && this.$filters ? 0 : -1;
    }

    onclick(event) {
        const team = event.target.closest('[data-team]');
        const alternative = event.target.closest('[data-location-option]');
        if (team) this.department = team.dataset.team;
        else if (alternative && this.$locationsSelect) {
            this.$locationsSelect.value = alternative.dataset.locationOption;
            this.$locationsSelect.focus({preventScroll: true});
        } else if (event.target === this.$clearFilters) {
            this.department = 'None';
            if (this.$locationsSelect) this.$locationsSelect.value = 'None';
            (this.$teamButtons?.[0] || this.$locationsSelect)?.focus({preventScroll: true});
        } else return;
        this.updateResults();
    }

    onchange() {
        this.updateResults();
    }

    updateResults() {
        const location = this.$locationsSelect?.value || 'None';
        const {visibleJobs, teamCounts, alternativeLocations} = filterCareers({jobs: this.jobs, department: this.department, location});
        const visible = new Set(visibleJobs);
        this.jobs.forEach((job) => {
            job.element.hidden = !visible.has(job);
        });
        (this.$teamButtons || []).forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.team === this.department));
            button.querySelector('[data-team-count]').textContent = teamCounts.get(button.dataset.team) || 0;
        });
        const count = visibleJobs.length;
        this.$count.textContent = `${count} open ${count === 1 ? 'position' : 'positions'}`;
        this.$noResultsMessage.hidden = count > 0;
        this.$emptyText.textContent = emptyCareersMessage(this.department, location);
        this.$clearFilters.hidden = this.department === 'None' && location === 'None';
        this.$alternatives.replaceChildren();
        this.$results.scrollTop = 0;
        if (count) return;
        for (const [place, available] of alternativeLocations) {
            const group = document.createElement('div');
            const text = document.createElement('p');
            text.textContent = `${available} open ${available === 1 ? 'position' : 'positions'} in ${place}.`;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'careers__alternative';
            button.dataset.locationOption = place;
            button.setAttribute('aria-controls', this.$count.closest('[id]').id);
            button.textContent = `View ${place} positions`;
            group.append(text, button);
            this.$alternatives.append(group);
        }
    }

    unmount() {
        this.$filters?.removeEventListener('click', this);
        this.$filters?.removeEventListener('change', this);
        this.$noResultsMessage.removeEventListener('click', this);
    }
}

registerModule('CareersList', CareersList);
